import React, { useState } from 'react';
import {
  CattleNvdWrapper,
  FormSection,
  ButtonsWrapper,
  FormButton,
  FormHeader,
  FormTitle,
  TwoColumns,
  FormField,
  CattleTable,
  TableWrapper,
  QuestionGroup,
  QuestionLabel,
  RadioGroup,
  DeclarationContainer,
  OutlineButton,
  FormTopHeader,
} from './cattleNvd.style';

const GoatsNvd = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    // NVD Number
    nvdNumber: 'G0524', // Pre-filled as shown in screenshot

    // Owner/goats details
    fullTradingName: '',
    propertyAddress: '',
    propertyTown: '',
    propertyState: '',
    propertyPostcode: '',
    propertyPIC: '',

    // Goats description
    goatsDescription: [
      {
        number: '',
        yearBorn: '',
        description: '',
        monthOfShearing: '',
        picOrBrand: '',
        earmarks: '',
      },
    ],

    // Consignment details
    consignedTo: '',
    destinationAddress: '',
    destinationState: '',
    destinationPIC: '',

    // Statutory documents
    documentType: '',
    documentNumber: '',
    dateOfIssue: '',
    expiryDate: '',

    // Part A Questions
    ownedByVendor: '', // Yes/No
    purchaseTimeframe: '', // A/B/C/D options
    withholdingPeriod: '', // Yes/No
    chemicalProducts: [{ product: '', treatmentDate: '', whp: '', esiIfSet: '' }],
    materialConsumed60Days: '', // Yes/No
    materialDetails: {
      product: '',
      dateApplied: '',
      grazingWhp: '',
      dateFirstFedGrazed: '',
      dateFeedingGrazingCeased: '',
    },
    animalFats: '', // Yes/No
    additionalInfo: '',

    // Declaration
    declarantName: '',
    declarantAddress: '',
    phone: '',
    fax: '',
    email: '',
    signature: '',
    date: '',

    // Part B - Transport details
    movementCommenced: '',
    vehicleRegistration: '',
    transporterName: '',
    transporterSignature: '',
    transporterDate: '',
    transporterTelNo: '',
  });

  const steps = [
    'NVD & Owner Details',
    'Goats Description',
    'Consignment Details',
    'Statutory Documents',
    'Part A - Questions 1-2',
    'Part A - Questions 3-5',
    'Declaration',
    'Part B - Transport',
  ];

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleGoatsDescriptionChange = (index, field, value) => {
    const newGoatsDescription = [...formData.goatsDescription];
    newGoatsDescription[index] = {
      ...newGoatsDescription[index],
      [field]: value,
    };
    setFormData((prev) => ({
      ...prev,
      goatsDescription: newGoatsDescription,
    }));
  };

  const addGoatsRow = () => {
    setFormData((prev) => ({
      ...prev,
      goatsDescription: [
        ...prev.goatsDescription,
        {
          number: '',
          yearBorn: '',
          description: '',
          monthOfShearing: '',
          picOrBrand: '',
          earmarks: '',
        },
      ],
    }));
  };

  const removeGoatsRow = (index) => {
    if (formData.goatsDescription.length > 1) {
      setFormData((prev) => ({
        ...prev,
        goatsDescription: prev.goatsDescription.filter((_, i) => i !== index),
      }));
    }
  };

  const handleChemicalProductChange = (index, field, value) => {
    const newChemicalProducts = [...formData.chemicalProducts];
    newChemicalProducts[index] = {
      ...newChemicalProducts[index],
      [field]: value,
    };
    setFormData((prev) => ({
      ...prev,
      chemicalProducts: newChemicalProducts,
    }));
  };

  const addChemicalProductRow = () => {
    setFormData((prev) => ({
      ...prev,
      chemicalProducts: [
        ...prev.chemicalProducts,
        { product: '', treatmentDate: '', whp: '', esiIfSet: '' },
      ],
    }));
  };

  const handleMaterialDetailsChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      materialDetails: {
        ...prev.materialDetails,
        [field]: value,
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Goats NVD Form Data:', formData);
    alert('Goats NVD Form submitted successfully!');
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <FormSection>
            <FormField>
              <label>NVD No:</label>
              <input
                type="text"
                name="nvd-number"
                value={formData.nvdNumber}
                onChange={(e) => handleInputChange('nvdNumber', e.target.value)}
                placeholder="Enter NVD Number"
                required
              />
            </FormField>

            <FormSection className="part-a-section">
              <h3 className="section-title">
                Part A - To be completed by the owner or person who is responsible for the husbandry
                of the goats
              </h3>

              <div className="subsection">
                <h4 className="subsection-title">Owner of goats</h4>
                <FormField>
                  <label>Full Trading Name *</label>
                  <input
                    type="text"
                    name="full-trading-name"
                    value={formData.fullTradingName}
                    onChange={(e) => handleInputChange('fullTradingName', e.target.value)}
                    placeholder="Enter full trading name"
                    required
                  />
                </FormField>
              </div>

              <div className="subsection">
                <h4 className="subsection-title">Property/place where the journey commenced</h4>
                <FormField>
                  <label>Address *</label>
                  <input
                    type="text"
                    name="property-address"
                    value={formData.propertyAddress}
                    onChange={(e) => handleInputChange('propertyAddress', e.target.value)}
                    placeholder="Enter property address"
                    required
                  />
                </FormField>

                <TwoColumns>
                  <FormField>
                    <label>Town/Suburb *</label>
                    <input
                      type="text"
                      name="property-town"
                      value={formData.propertyTown}
                      onChange={(e) => handleInputChange('propertyTown', e.target.value)}
                      placeholder="Enter town/suburb"
                      required
                    />
                  </FormField>
                  <FormField>
                    <label>State *</label>
                    <select
                      name="property-state"
                      value={formData.propertyState}
                      onChange={(e) => handleInputChange('propertyState', e.target.value)}
                      required
                    >
                      <option value="">Select State</option>
                      <option value="NSW">NSW</option>
                      <option value="VIC">VIC</option>
                      <option value="QLD">QLD</option>
                      <option value="WA">WA</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="NT">NT</option>
                      <option value="ACT">ACT</option>
                    </select>
                  </FormField>
                </TwoColumns>

                <FormField>
                  <label>Property Identification Code (PIC) of this property *</label>
                  <input
                    type="text"
                    name="property-pic"
                    value={formData.propertyPIC}
                    onChange={(e) => handleInputChange('propertyPIC', e.target.value)}
                    placeholder="This MUST be the PIC of the property that the stock is being moved from"
                    required
                  />
                </FormField>
              </div>
            </FormSection>
          </FormSection>
        );

      case 1:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Description of goats</h3>
            </FormHeader>

            <TableWrapper>
              <CattleTable>
                <thead>
                  <tr>
                    <th>Number</th>
                    <th>Year born</th>
                    <th>Description (BREED, SEX & TYPE e.g. DOES BRED)</th>
                    <th>Month of shearing</th>
                    <th>PIC or Brand on Ear Tags (IF DIFFERENT TO PIC SHOWN ABOVE)</th>
                    <th>Earmarks (IF PRESENT OR REQUIRED)</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.goatsDescription.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="number"
                          value={row.number}
                          onChange={(e) =>
                            handleGoatsDescriptionChange(index, 'number', e.target.value)
                          }
                          placeholder="Qty"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.yearBorn}
                          onChange={(e) =>
                            handleGoatsDescriptionChange(index, 'yearBorn', e.target.value)
                          }
                          placeholder="Year"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.description}
                          onChange={(e) =>
                            handleGoatsDescriptionChange(index, 'description', e.target.value)
                          }
                          placeholder="e.g., Angus Cross Does, Bred"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.monthOfShearing}
                          onChange={(e) =>
                            handleGoatsDescriptionChange(index, 'monthOfShearing', e.target.value)
                          }
                          placeholder="Month"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.picOrBrand}
                          onChange={(e) =>
                            handleGoatsDescriptionChange(index, 'picOrBrand', e.target.value)
                          }
                          placeholder="PIC/Brand"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.earmarks}
                          onChange={(e) =>
                            handleGoatsDescriptionChange(index, 'earmarks', e.target.value)
                          }
                          placeholder="Earmarks"
                        />
                      </td>
                      <td>
                        <FormButton
                          type="button"
                          onClick={() => removeGoatsRow(index)}
                          className="remove-btn"
                          disabled={formData.goatsDescription.length === 1}
                        >
                          Remove
                        </FormButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </CattleTable>
            </TableWrapper>

            <FormButton type="button" onClick={addGoatsRow}>
              + Add Row
            </FormButton>

            <div
              className="note"
              style={{
                marginTop: '1rem',
                padding: '0.5rem',
                fontSize: '0.9rem',
              }}
            >
              <strong>Total:</strong> Use the Attachment Forms for consignments that require more
              lines to describe the stock. (See Explanatory Notes)
            </div>
          </FormSection>
        );

      case 2:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Consignment Details</h3>
            </FormHeader>

            <FormField>
              <label>Consigned to *</label>
              <input
                type="text"
                name="consigned-to"
                value={formData.consignedTo}
                onChange={(e) => handleInputChange('consignedTo', e.target.value)}
                placeholder="(NAME OF PERSON OR BUSINESS)"
                required
              />
            </FormField>

            <FormField>
              <label>Destination Address *</label>
              <input
                type="text"
                name="destination-address"
                value={formData.destinationAddress}
                onChange={(e) => handleInputChange('destinationAddress', e.target.value)}
                placeholder="Enter destination address"
                required
              />
            </FormField>

            <TwoColumns>
              <FormField>
                <label>Town/Suburb</label>
                <input
                  type="text"
                  name="destination-town"
                  value={formData.destinationTown || ''}
                  onChange={(e) => handleInputChange('destinationTown', e.target.value)}
                  placeholder="Enter town/suburb"
                />
              </FormField>
              <FormField>
                <label>State *</label>
                <select
                  name="destination-state"
                  value={formData.destinationState}
                  onChange={(e) => handleInputChange('destinationState', e.target.value)}
                  required
                >
                  <option value="">Select State</option>
                  <option value="NSW">NSW</option>
                  <option value="VIC">VIC</option>
                  <option value="QLD">QLD</option>
                  <option value="WA">WA</option>
                  <option value="SA">SA</option>
                  <option value="TAS">TAS</option>
                  <option value="NT">NT</option>
                  <option value="ACT">ACT</option>
                </select>
              </FormField>
            </TwoColumns>

            <div className="subsection">
              <h4 className="subsection-title">Destination (if different) of goats</h4>
              <FormField>
                <label>Location Address</label>
                <input
                  type="text"
                  name="different-destination-address"
                  value={formData.differentDestinationAddress || ''}
                  onChange={(e) => handleInputChange('differentDestinationAddress', e.target.value)}
                  placeholder="Enter different destination if applicable"
                />
              </FormField>
            </div>

            <FormField>
              <label>Destination PIC (REQ: WA & TAS)</label>
              <input
                type="text"
                name="destination-pic"
                value={formData.destinationPIC}
                onChange={(e) => handleInputChange('destinationPIC', e.target.value)}
                placeholder="Enter destination PIC"
              />
            </FormField>
          </FormSection>
        );

      case 3:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">
                Details of other statutory documents relating to this movement (eg. health
                statement)
              </h3>
            </FormHeader>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '1rem' }}>
              <FormField>
                <label>Document Type</label>
                <input
                  type="text"
                  name="document-type"
                  value={formData.documentType}
                  onChange={(e) => handleInputChange('documentType', e.target.value)}
                  placeholder="Document Type"
                />
              </FormField>
              <FormField>
                <label>Number</label>
                <input
                  type="text"
                  name="document-number"
                  value={formData.documentNumber}
                  onChange={(e) => handleInputChange('documentNumber', e.target.value)}
                  placeholder="Number"
                />
              </FormField>
              <FormField>
                <label>Date of Issue</label>
                <input
                  type="date"
                  name="date-of-issue"
                  value={formData.dateOfIssue}
                  onChange={(e) => handleInputChange('dateOfIssue', e.target.value)}
                />
              </FormField>
              <FormField>
                <label>Expiry Date</label>
                <input
                  type="date"
                  name="expiry-date"
                  value={formData.expiryDate}
                  onChange={(e) => handleInputChange('expiryDate', e.target.value)}
                />
              </FormField>
            </div>
          </FormSection>
        );

      case 4:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part A - Questions 1-2</h3>
            </FormHeader>

            <QuestionGroup>
              <QuestionLabel>① Were all goats bred by the owner or vendor?</QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="owned-by-vendor"
                    value="yes"
                    checked={formData.ownedByVendor === 'yes'}
                    onChange={(e) => handleInputChange('ownedByVendor', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="owned-by-vendor"
                    value="no"
                    checked={formData.ownedByVendor === 'no'}
                    onChange={(e) => handleInputChange('ownedByVendor', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>

              {formData.ownedByVendor === 'no' && (
                <div style={{ marginTop: '1rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                    If No, how long were the goats obtained or purchased?
                  </label>
                  <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
                    (If purchased at different times, tick the box corresponding to the time of the
                    most recent purchase.)
                  </p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="purchase-timeframe"
                        value="A"
                        checked={formData.purchaseTimeframe === 'A'}
                        onChange={(e) => handleInputChange('purchaseTimeframe', e.target.value)}
                      />
                      <span className="radio-label">A. Less than 2 months</span>
                    </label>
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="purchase-timeframe"
                        value="B"
                        checked={formData.purchaseTimeframe === 'B'}
                        onChange={(e) => handleInputChange('purchaseTimeframe', e.target.value)}
                      />
                      <span className="radio-label">B. 2-6 months</span>
                    </label>
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="purchase-timeframe"
                        value="C"
                        checked={formData.purchaseTimeframe === 'C'}
                        onChange={(e) => handleInputChange('purchaseTimeframe', e.target.value)}
                      />
                      <span className="radio-label">C. 6-12 months</span>
                    </label>
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="purchase-timeframe"
                        value="D"
                        checked={formData.purchaseTimeframe === 'D'}
                        onChange={(e) => handleInputChange('purchaseTimeframe', e.target.value)}
                      />
                      <span className="radio-label">D. more than 12 months</span>
                    </label>
                  </div>
                </div>
              )}
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                ② Are any of the goats in this consignment still within a Withholding Period (WHP)
                or Export Slaughter Interval (ESI) as set by APVMA or SAFEMEAT, following treatment
                with any veterinary drug or chemical?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="withholding-period"
                    value="yes"
                    checked={formData.withholdingPeriod === 'yes'}
                    onChange={(e) => handleInputChange('withholdingPeriod', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="withholding-period"
                    value="no"
                    checked={formData.withholdingPeriod === 'no'}
                    onChange={(e) => handleInputChange('withholdingPeriod', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>

              {formData.withholdingPeriod === 'yes' && (
                <div style={{ marginTop: '1rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                    If Yes, give details: (Record additional details in question 6)
                  </label>
                  <TableWrapper>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid #ddd', padding: '8px' }}>
                            Chemical Product
                          </th>
                          <th style={{ border: '1px solid #ddd', padding: '8px' }}>
                            Treatment Date
                          </th>
                          <th style={{ border: '1px solid #ddd', padding: '8px' }}>WHP</th>
                          <th style={{ border: '1px solid #ddd', padding: '8px' }}>ESI (IF SET)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.chemicalProducts.map((row, index) => (
                          <tr key={index}>
                            <td style={{ border: '1px solid #ddd', padding: '4px' }}>
                              <input
                                type="text"
                                value={row.product}
                                onChange={(e) =>
                                  handleChemicalProductChange(index, 'product', e.target.value)
                                }
                                style={{ width: '100%', border: 'none', padding: '4px' }}
                              />
                            </td>
                            <td style={{ border: '1px solid #ddd', padding: '4px' }}>
                              <input
                                type="text"
                                value={row.treatmentDate}
                                onChange={(e) =>
                                  handleChemicalProductChange(
                                    index,
                                    'treatmentDate',
                                    e.target.value
                                  )
                                }
                                style={{ width: '100%', border: 'none', padding: '4px' }}
                                placeholder="/  /20"
                              />
                            </td>
                            <td style={{ border: '1px solid #ddd', padding: '4px' }}>
                              <input
                                type="text"
                                value={row.whp}
                                onChange={(e) =>
                                  handleChemicalProductChange(index, 'whp', e.target.value)
                                }
                                style={{ width: '100%', border: 'none', padding: '4px' }}
                              />
                            </td>
                            <td style={{ border: '1px solid #ddd', padding: '4px' }}>
                              <input
                                type="text"
                                value={row.esiIfSet}
                                onChange={(e) =>
                                  handleChemicalProductChange(index, 'esiIfSet', e.target.value)
                                }
                                style={{ width: '100%', border: 'none', padding: '4px' }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </TableWrapper>
                  <FormButton
                    type="button"
                    onClick={addChemicalProductRow}
                    style={{ marginTop: '0.5rem' }}
                  >
                    + Add Chemical Product
                  </FormButton>
                </div>
              )}
            </QuestionGroup>
          </FormSection>
        );

      case 5:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part A - Questions 3-5</h3>
            </FormHeader>

            <QuestionGroup>
              <QuestionLabel>
                ③ In the past 60 days, have any of these goats consumed any material that was still
                within a withholding period when harvested, collected or first grazed?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="material-consumed-60days"
                    value="yes"
                    checked={formData.materialConsumed60Days === 'yes'}
                    onChange={(e) => handleInputChange('materialConsumed60Days', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="material-consumed-60days"
                    value="no"
                    checked={formData.materialConsumed60Days === 'no'}
                    onChange={(e) => handleInputChange('materialConsumed60Days', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>

              {formData.materialConsumed60Days === 'yes' && (
                <div style={{ marginTop: '1rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                    If Yes, give details:
                  </label>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
                      gap: '0.5rem',
                      marginBottom: '0.5rem',
                    }}
                  >
                    <div style={{ fontSize: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>
                      Chemical Product
                    </div>
                    <div style={{ fontSize: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>
                      Date Applied
                    </div>
                    <div style={{ fontSize: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>
                      Grazing WHP
                    </div>
                    <div style={{ fontSize: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>
                      Date First Fed/Grazed
                    </div>
                    <div style={{ fontSize: '0.9rem', fontWeight: 'bold', textAlign: 'center' }}>
                      Date Feeding/Grazing Ceased
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
                      gap: '0.5rem',
                    }}
                  >
                    <input
                      type="text"
                      value={formData.materialDetails.product}
                      onChange={(e) => handleMaterialDetailsChange('product', e.target.value)}
                      style={{ padding: '4px' }}
                    />
                    <input
                      type="text"
                      value={formData.materialDetails.dateApplied}
                      onChange={(e) => handleMaterialDetailsChange('dateApplied', e.target.value)}
                      style={{ padding: '4px' }}
                      placeholder="/  /20"
                    />
                    <input
                      type="text"
                      value={formData.materialDetails.grazingWhp}
                      onChange={(e) => handleMaterialDetailsChange('grazingWhp', e.target.value)}
                      style={{ padding: '4px' }}
                    />
                    <input
                      type="text"
                      value={formData.materialDetails.dateFirstFedGrazed}
                      onChange={(e) =>
                        handleMaterialDetailsChange('dateFirstFedGrazed', e.target.value)
                      }
                      style={{ padding: '4px' }}
                      placeholder="/  /20"
                    />
                    <input
                      type="text"
                      value={formData.materialDetails.dateFeedingGrazingCeased}
                      onChange={(e) =>
                        handleMaterialDetailsChange('dateFeedingGrazingCeased', e.target.value)
                      }
                      style={{ padding: '4px' }}
                      placeholder="/  /20"
                    />
                  </div>
                </div>
              )}
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                ④ Have the goats in this consignment ever in their lives been fed food containing
                animal fats?
                <br />
                <span style={{ fontSize: '0.9rem', color: '#666' }}>(See Explanatory Notes)</span>
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="animal-fats"
                    value="yes"
                    checked={formData.animalFats === 'yes'}
                    onChange={(e) => handleInputChange('animalFats', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="animal-fats"
                    value="no"
                    checked={formData.animalFats === 'no'}
                    onChange={(e) => handleInputChange('animalFats', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
            </QuestionGroup>
          </FormSection>
        );
      case 6:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Declaration</h3>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Full Name *</label>
                <input
                  type="text"
                  name="declarant-name"
                  value={formData.declarantName}
                  onChange={(e) => handleInputChange('declarantName', e.target.value)}
                  placeholder="Enter full name"
                  required
                />
              </FormField>
              <FormField>
                <label>Full Address *</label>
                <input
                  type="text"
                  name="declarant-address"
                  value={formData.declarantAddress}
                  onChange={(e) => handleInputChange('declarantAddress', e.target.value)}
                  placeholder="Enter full address"
                  required
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Address (Cont.)</label>
              <input
                type="text"
                name="declarant-address-cont"
                value={formData.declarantAddressCont || ''}
                onChange={(e) => handleInputChange('declarantAddressCont', e.target.value)}
                placeholder="Enter additional address details if needed"
              />
            </FormField>

            <DeclarationContainer>
              <div className="declaration-text">
                <h4>Declaration Statement</h4>
                <p>
                  <strong>
                    I declare that, I am the owner or the person responsible for the husbandry of
                    the goats and that all the information in part A of this document is true and
                    correct. I also declare that I have read and understood all the questions that I
                    have answered, that I have read and understood the explanatory notes, and that,
                    while under my control, the goats were not fed restricted animal material
                    (including meat and bone meal) in breach of State or Territory legislation.
                  </strong>
                </p>
                <p style={{ fontSize: '0.9rem', fontStyle: 'italic', marginTop: '1rem' }}>
                  *Only the person whose name appears above may sign this declaration, or make
                  amendments which must be initialled.
                </p>
              </div>

              <div
                style={{ display: 'flex', gap: '2rem', alignItems: 'flex-end', marginTop: '2rem' }}
              >
                <FormField style={{ flex: 1 }}>
                  <label>Signature *</label>
                  <input
                    type="text"
                    name="signature"
                    value={formData.signature}
                    onChange={(e) => handleInputChange('signature', e.target.value)}
                    placeholder="Signature"
                    required
                  />
                </FormField>
                <FormField style={{ flex: 1 }}>
                  <label>Date *</label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={(e) => handleInputChange('date', e.target.value)}
                    required
                  />
                </FormField>
              </div>

              <TwoColumns style={{ marginTop: '1rem' }}>
                <FormField>
                  <label>Tel no.</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => handleInputChange('phone', e.target.value)}
                    placeholder="Enter phone number"
                  />
                </FormField>
                <FormField>
                  <label>Fax no.</label>
                  <input
                    type="tel"
                    name="fax"
                    value={formData.fax}
                    onChange={(e) => handleInputChange('fax', e.target.value)}
                    placeholder="Enter fax number"
                  />
                </FormField>
              </TwoColumns>

              <FormField>
                <label>Email.</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => handleInputChange('email', e.target.value)}
                  placeholder="Enter email address"
                />
              </FormField>
            </DeclarationContainer>
          </FormSection>
        );

      case 7:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">
                Part B - To be completed by the person in charge of the goats while they are being
                moved.
              </h3>
              <p className="section-subtitle">Completion of this part is optional in SA and VIC.</p>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Movement commenced: (Date/Time)</label>
                <input
                  type="datetime-local"
                  name="movement-commenced"
                  value={formData.movementCommenced}
                  onChange={(e) => handleInputChange('movementCommenced', e.target.value)}
                />
              </FormField>
              <FormField>
                <label>Vehicle registration number(s) *</label>
                <input
                  type="text"
                  name="vehicle-registration"
                  value={formData.vehicleRegistration}
                  onChange={(e) => handleInputChange('vehicleRegistration', e.target.value)}
                  placeholder="Enter vehicle registration"
                />
                <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.25rem' }}>
                  *When more than one truck is carrying the goats, other vehicle registration
                  numbers are to be recorded.
                </p>
              </FormField>
            </TwoColumns>

            <FormField>
              <label>
                I _________________ am the person in charge of the goats during the movement and
                declare all the information in Part B is true and correct.
              </label>
              <input
                type="text"
                name="transporter-name"
                value={formData.transporterName}
                onChange={(e) => handleInputChange('transporterName', e.target.value)}
                placeholder="Enter full name"
                style={{ marginTop: '0.5rem' }}
              />
            </FormField>

            <TwoColumns>
              <FormField>
                <label>Signature</label>
                <input
                  type="text"
                  name="transporter-signature"
                  value={formData.transporterSignature}
                  onChange={(e) => handleInputChange('transporterSignature', e.target.value)}
                  placeholder="Signature"
                />
              </FormField>
              <FormField>
                <label>Date</label>
                <input
                  type="date"
                  name="transporter-date"
                  value={formData.transporterDate}
                  onChange={(e) => handleInputChange('transporterDate', e.target.value)}
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Tel no.</label>
              <input
                type="tel"
                name="transporter-tel"
                value={formData.transporterTelNo}
                onChange={(e) => handleInputChange('transporterTelNo', e.target.value)}
                placeholder="Enter telephone number"
              />
            </FormField>
          </FormSection>
        );

      default:
        return null;
    }
  };

  return (
    <CattleNvdWrapper>
      <FormTopHeader>
        <FormTitle>National Vendor Declaration (Goats) and Waybill</FormTitle>
        <p className="subtitle">
          This form cannot be used where eligibility for the EU market is required.
        </p>
      </FormTopHeader>
      <form onSubmit={handleSubmit}>
        <ButtonsWrapper>
          {currentStep > 0 && (
            <OutlineButton type="button" onClick={prevStep} style={{ maxWidth: 'fit-content' }}>
              ← Back
            </OutlineButton>
          )}

          {currentStep < steps.length - 1 ? (
            <OutlineButton type="button" onClick={nextStep}>
              Next →
            </OutlineButton>
          ) : (
            <OutlineButton type="submit">Submit NVD</OutlineButton>
          )}
        </ButtonsWrapper>
        <div className="form-content">{renderStep()}</div>
      </form>
    </CattleNvdWrapper>
  );
};

export default GoatsNvd;
